import { App } from 'vue'
import { getAttr } from '../utils/getParams'
import { setParamsFromUrl } from '../utils/getUrlParams'
import { initTrackerParams } from '../utils/getTrackerParams'
import { getEnv } from '@nio-wad/hooks'
import { setPropertyWithTheme } from '../theme/setProperty'
import { handleInjection } from '../utils/initVconsole'
import { OS } from '@/utils/device'

export default async ({ app }: { app: App<any> }) => {
  setPropertyWithTheme() // 根据配置写入全局样式变量
  // 一些启动时的init处理
  const env = getEnv()
  console.log = env === 'prod' ? () => {} : console.log
  // console.log = () => {}
  handleInjection()
  setParamsFromUrl()
  initTrackerParams()
  getAttr()
  console.log('====================================')
  console.log('navigator.userAgent', navigator.userAgent)
  console.log('====================================')
  console.log('====================================')
  console.log('OS.isAndroid', OS.isAndroid)
  console.log('OS.isNioBrowser', OS.isNioBrowser)
  console.log('====================================')
}
